import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import SortObject from "../../types/SortObject";
import LeadModel from "../../viewModels/Lead/LeadModel";
import { LeadFiltersType } from "./components/LeadFilters";
import createMessageModalSlice from "../../widgets/CreateMessageModal/reducer";
import { MessageDataConverter } from "../../viewModels/Message/MessageModel";

const pageSizeLsKey = "leads_table_pageSize";
const pageSizeFromLs = localStorage.getItem(pageSizeLsKey);

const initialState: {
  loading: boolean;
  loadingData: boolean;
  error: boolean;
  page: number;
  pageSize: number;
  leads?: Array<LeadModel>;
  sort?: SortObject;
  total?: number;
  filters?: LeadFiltersType;
} = {
  loading: true,
  loadingData: false,
  error: false,
  page: undefined!,
  pageSize: pageSizeFromLs ? +pageSizeFromLs : 10,
  sort: {
    key: "creationDate",
    order: "descend",
  },
};

const leadsSlice = createSlice({
  name: "leads",
  initialState,
  reducers: {
    loadLeads(state) {
      state.error = false;
      state.loadingData = true;
      state.page = 1;
    },
    loadLeadsSuccess(state, action: PayloadAction<{ leads?: Array<LeadModel>; total: number }>) {
      const { leads, total } = action.payload;

      state.loading = false;
      state.error = false;
      state.loadingData = false;
      state.leads = leads;
      state.total = total;
    },

    loadLeadsReject(state) {
      state.error = true;
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort?: SortObject; filters: LeadFiltersType }>) {
      state.error = false;
      const { page, pageSize, filters } = action.payload;
      state.loadingData = true;
      state.page = page;
      state.pageSize = pageSize;
      state.sort = action.payload.sort;
      localStorage.setItem(pageSizeLsKey, `${pageSize}`);
      state.filters = filters;
    },
  },
  extraReducers(builder) {
    builder.addCase(createMessageModalSlice.actions.createMessageSuccess, (state, action) => {
      const leadIndex = (state.leads || []).findIndex((x) => x.id === action.payload.leadId);
      if (state.leads && leadIndex !== -1) {
        state.leads[leadIndex] = {
          ...state.leads[leadIndex],
          messages: [MessageDataConverter.convertMessage(action.payload), ...state.leads[leadIndex].messages],
        };
      }
    });
  },
});

export default leadsSlice;
